import type { Resource } from '../../';
export const forms_address_state: Resource = {"default":"State"};
